import { createContext } from "react";

const OsContext = createContext({});

export default OsContext;
